import { createFileRoute } from '@tanstack/react-router'
import LeadImportarPage from '@/pages/leads/lead-importar'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota para importar leads via arquivo CSV/XLS
// Path completo será /dashboard/$dashboardId/leads/importar
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/leads/importar',
)({
  component: function LeadImportarRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.LEADS_ALL, CAPABILITIES.LEADS_OWN]}
        dashboardId={dashboardId}
      >
        <LeadImportarPage dashboardId={dashboardId} />
      </ProtectedRoute>
    )
  },
})
